import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Push_Service/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmLivestreamPerm';
import PushTable from 'components/Web_User_Interface/1440p_Series/Alarm/Push_Service/pushTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü // Push Dienst",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/Push_Dienst/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Ihre Kamera kann Sie per Email informieren, jedes Mal, wenn die Bewegungserkennung ausgelöst hat. Eine Push-Benachrichtigung erfüllt den selben Zweck, ist aber viel schneller! Aktivieren Sie die Push-Benachrichtigung, wenn Sie direkt über einen Alarm informiert werden möchten. Die Push-Benachrichtigung funktioniert nur mit der InstarVision App für iOs, Windows Phone, Windows Metro oder Android Geräte.",
  "image": "./WebUI_1440p_SearchThumb_Alarm_Push_Service.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm_Push_Service.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Alarm Menü // Push Dienst' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ihre Kamera kann Sie per Email informieren, jedes Mal, wenn die Bewegungserkennung ausgelöst hat. Eine Push-Benachrichtigung erfüllt den selben Zweck, ist aber viel schneller! Aktivieren Sie die Push-Benachrichtigung, wenn Sie direkt über einen Alarm informiert werden möchten. Die Push-Benachrichtigung funktioniert nur mit der InstarVision App für iOs, Windows Phone, Windows Metro oder Android Geräte.' image='/images/Search/WebUI_1440p_SearchThumb_Alarm_Push_Service.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm_Push_Service.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Push_Service/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Push_Service/' crumbLabel="Push Service" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-men%C3%BC",
        "aria-label": "alarm menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/47aef/1440p_Settings_Alarm_Push.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACXUlEQVQoz1XS3U9ScRzHcf+LvHSFND1aW4C2xTkcDggIBzgHOBwQHXoMUXkYKNCWD7MMn+qiO2Vrq9Q11z/Qmpl20d/1LjDHunjte/fZ5/v9/QYEQUAYG2PE/oDJ8Dyhtc/4S8f4yx185Q7S8jHSyknf8jGBSodI/QOPJr1MB6cYGhpicPBebw6Mjo4iCGM8tN3Hoy0y9/orM5un5LbPezKb55gbp/+c9ebs9hn5nS+4/RqSW2J8/DHC6DgjI8JdoMCw3Y747CnZVIy0HiGtq6Ti06RiIZJ3oiES0SC6GsDQIqghHVny4ZX9KN4ALuckA72VBQG73Y5bFDHSGWJxDTUaR41pROM6cT3Zo+lJUoZJKm2Sn7eYTWYJB714ZQVJ9OF4MnHbsMtmsxEIBGk0GtRqNWrVMvVqiVq1xFqt0lMtr2AkNfS4SiIeY9VSMQ0ZyS3jkXz9ht3A4eFhFEWhWCxiWRaF2iZLzT2W1ncpNts9hfVdssUWZqFJptCgWgyjhd3IksyUouByTfQDuyuLoshMNktC1zA3zjEPfmG2LzH3fmDuXZHZvyJ3+JPc0Q25ve90NlsYYRmv7CHgV3A6Xf839Hg8ZHJzxHQDc+uC3LvfzBxe39q/7DEPrzGObkgeXHJx8JZqMoRbklBkHw6Hq3/D7itLkkhpPkUlr5F/vkrSapKy6qQKL0hX9jHKbRasBivza+StdY7fbNFejDDl695QwemYuHvlbkM7suTmU0vl26sQLxdCqGr09puYc6SbJyTq79lRE3z0+9kKRzhsVdmYCWHEpxDdXhx/A/8ApZWPcydwdFcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/042050eaa3fda9eb8dfc75ed94522dbe/e4706/1440p_Settings_Alarm_Push.avif 230w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/d1af7/1440p_Settings_Alarm_Push.avif 460w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/7f308/1440p_Settings_Alarm_Push.avif 920w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/29832/1440p_Settings_Alarm_Push.avif 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/042050eaa3fda9eb8dfc75ed94522dbe/a0b58/1440p_Settings_Alarm_Push.webp 230w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/bc10c/1440p_Settings_Alarm_Push.webp 460w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/966d8/1440p_Settings_Alarm_Push.webp 920w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/0ca5b/1440p_Settings_Alarm_Push.webp 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/042050eaa3fda9eb8dfc75ed94522dbe/81c8e/1440p_Settings_Alarm_Push.png 230w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/08a84/1440p_Settings_Alarm_Push.png 460w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/c0255/1440p_Settings_Alarm_Push.png 920w", "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/47aef/1440p_Settings_Alarm_Push.png 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/042050eaa3fda9eb8dfc75ed94522dbe/c0255/1440p_Settings_Alarm_Push.png",
              "alt": "Web User Interface - 1440p Series - Alarm Push Service",
              "title": "Web User Interface - 1440p Series - Alarm Push Service",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PushTable mdxType="PushTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      